import {Component} from 'react';
import axios from "axios"
import Nav from "./Nav";
import Swal from "sweetalert2";
import myconfig from "../myconfig";
import $ from 'jquery';
import { Modal,Button } from 'react-bootstrap';

let source = axios.CancelToken.source();

class AllocateCU extends Component {
    constructor() {
        super();
        this.state = {

            value:null,
            locations:[],
            locationload:false,
            locationselected:"-1",
            cur_location:'',
            cur_cor:'',
            cur_avl:'',
            cur_distance:'',
            cur_short_name:'',
            cur_fuel_empty:'',
            cur_handling_fee:'',
            menu: 'g-sidenav-show bg-gray-100',
            objs:[],
            objsload:false,
            assignment_id:"-1",

            estfuelqtyload:'',
            estpredieload:'',
            esthandlefeeload:'',
            estfuelqtyempty:'',
            estprediemempty:'',
            esthandlefeeempty:'',

            a_distance_empty:'',
            a_fule_empty:'',

            truck:'',
            capcity:'',
            type:'',
            transporter:'',
            trailer:'',
            driver:'',
            licence:'',
            validity:'',
            phone:'',

            actfuelqtyempty:0,
            actprediemempty:0,
            acthandlefeeempty:0,
            actfuelqtyload:0,
            actpredieload:0,
            acthandlefeeload:0,
            commesa:0,
            boardercost:0,

            dateofallocation:'',
            dateofarivalatloadpoint:'',
            dateofloading:'',
            dateofdeparture:'',
            dateofarivalatboarder:'',
            dateofarivalatoffloadpoint:'',
            dateofoffloading:'',
            dateofallocationt:'',
            dateofarivalatloadpointt:'',
            dateofloadingt:'',
            dateofdeparturet:'',
            dateofarivalatoffloadpointt:'',
            dateofoffloadingt:'',

            fuelrate:'',
            otherexpense:'',
            supervisor:'',
            loadedweight:'',

            //modal
            assignshow:false,
            wizard:1,
            wiz_algo:1,
            vehicles:[],
            vehicleload:false,
            //wiz_algo 1 means waitng for order so it means if for the corrdination found
            //wiz_algo 2 means same as orgin
            //wiz_algo 3 means same as from route master
            //wiz_algo 4  means same as from Gps master
            //wiz_algo 5  means same as other

            msg:'allocation',

            urlallocate:'',

        }
    }

    async componentDidMount() {
        let baseurl = myconfig.getallocate;
        let redirecttologin = myconfig.redirecttologin;
        let sid = new URLSearchParams(this.props.location.search).get("sid");
        let user = new URLSearchParams(this.props.location.search).get("user");
        let order_id = new URLSearchParams(this.props.location.search).get("order_id");
        let allocate_id = new URLSearchParams(this.props.location.search).get("allocate_id");
        this.setState({
            urlallocate: myconfig.allocate + "?sid=" + sid + "&user=" + user+ "&order_id=" + order_id,
        })
        await axios.post(baseurl, {
            "sid": sid,
            "user": user,
            "allocate_id": allocate_id,
        }, {cancelToken: source.token}).then(res => {
            console.log(res.data)
            if (res.data.auth == false) {
                /*  window.localStorage.setItem("fas_sid", null);
                  window.localStorage.setItem("fas_username", null);
                  window.localStorage.setItem("fas_name", null);
                  var win = window.open(redirecttologin, "_self");*/
            } else if (res.data.success == false) {
                Swal.fire({
                    title: 'Error!',
                    text: res.data.message,
                    icon: 'error',
                    confirmButtonText: 'Okay'
                })
            } else {
                if (res.data.isfound) {
                    this.setState({
                        objs: res.data,
                        objsload: true,
                        a_distance_empty: res.data.cost.a_distance_empty,
                        a_fule_empty: res.data.cost.a_fule_empty,
                        estfuelqtyempty: res.data.cost.estfuelqtyempty,
                        estprediemempty: res.data.cost.estprediemempty,
                        esthandlefeeempty: res.data.cost.esthandlefeeempty,
                        estfuelqtyload: res.data.cost.estfuelqtyload,
                        estpredieload: res.data.cost.estpredieload,
                        esthandlefeeload: res.data.cost.esthandlefeeload,
                        actfuelqtyempty: res.data.cost.actfuelqtyempty,
                        actprediemempty: res.data.cost.actprediemempty,
                        acthandlefeeempty: res.data.cost.acthandlefeeempty,
                        actfuelqtyload: res.data.cost.actfuelqtyload,
                        actpredieload: res.data.cost.actpredieload,
                        acthandlefeeload: res.data.cost.acthandlefeeload,
                        commesa: res.data.cost.commesa,
                        boardercost: res.data.cost.boardercost,
                        wiz_algo: res.data.cost.wiz_algo,
                        assignment_id:res.data.truck.assignment_id,
                        truck: res.data.truck.truck,
                        capcity: res.data.truck.capcity,
                        type: res.data.truck.type,
                        transporter: res.data.truck.transporter,
                        trailer: res.data.truck.trailer,
                        driver: res.data.truck.driver,
                        licence: res.data.truck.licence,
                        validity: res.data.truck.validity,
                        phone: res.data.truck.phone,

                        dateofallocation: res.data.allocatedate.dateofallocation,
                        dateofarivalatloadpoint: res.data.allocatedate.dateofarivalatloadpoint,
                        dateofloading: res.data.allocatedate.dateofloading,
                        dateofdeparture: res.data.allocatedate.dateofdeparture,
                        dateofarivalatboarder: res.data.allocatedate.dateofarivalatboarder,
                        dateofdepartureatboarder: res.data.allocatedate.dateofdepartureatboarder,
                        dateofarivalatoffloadpoint: res.data.allocatedate.dateofarivalatoffloadpoint,
                        dateofoffloading: res.data.allocatedate.dateofoffloading,
                        dateofallocationt: res.data.allocatedate.dateofallocationt,
                        dateofarivalatloadpointt: res.data.allocatedate.dateofarivalatloadpointt,
                        dateofloadingt: res.data.allocatedate.dateofloadingt,
                        dateofdeparturet: res.data.allocatedate.dateofdeparturet,
                        dateofarivalatboardert: res.data.allocatedate.dateofarivalatboardert,
                        dateofdepartureatboardert: res.data.allocatedate.dateofdepartureatboardert,
                        dateofarivalatoffloadpointt: res.data.allocatedate.dateofarivalatoffloadpointt,
                        dateofoffloadingt: res.data.allocatedate.dateofoffloadingt,

                        supervisor: res.data.otherinfo.supervisor,
                        fuelrate: res.data.otherinfo.fuelrate,
                        loadedweight: res.data.otherinfo.loadedweight,
                        otherexpense: res.data.otherinfo.otherexpense,


                    })
                } else {
                    console.log(this.state.urlorder)
                    let u=myconfig.allocate + "?sid=" + sid + "&user=" + user+ "&order_id=" + order_id
                    var win = window.open(u, "_self");
                }

            }
        }).catch((e) => {
            console.log(e.message);
        });
    }

    wizard_1=()=>{
        let tabledata=null;
        if(this.state.vehicleload){
            let count=0;
            tabledata = this.state.vehicles.map(value => {
                count = count + 1
                return (<tr>
                    <td>{count}</td>
                    <td>
                        <a href="#" onClick={(event => this.wizard_1_btn(event,value))}> Select </a>
                    </td>
                    <td>{value.plate_no}</td>
                    <td>{value.tran_name}</td>
                    <td>{value.tran_type}</td>
                    <td>{value.dri_name}</td>
                    <td>{value.dri_phoneno}</td>
                    <td>{value.tra_plateno}</td>
                    <td>{value.loc}</td>
                    <td>{value.avl}</td>
                    <td>{value.status}</td>
                </tr>)
            })
        }

        return(<>
            <div className="card">
                <div className="card-header">
                    <div className="card-tools">
                        <div className="input-group input-group-sm" style={{width: '150px'}}>
                            <input type="text" name="table_search" className="form-control float-right" placeholder="Search" />
                            <div className="input-group-append">
                                <button type="submit" className="btn btn-default">
                                    <i className="fas fa-search" />
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="card-header">
                    <h3 className="card-title">Available Truck List</h3>
                    <div className="card-tools">
                    </div>
                </div>
                {/* /.card-header */}
                <div className="card-body table-responsive p-0" style={{height: '500px'}}>
                    <table className="table table-head-fixed text-nowrap">
                        <thead>
                        <tr>
                            <th>#</th>
                            <th>Action</th>
                            <th>Plate No </th>
                            <th>Transporter</th>
                            <th>Type</th>
                            <th>Driver Name</th>
                            <th>Phone #</th>
                            <th>Trailer</th>
                            <th>Location</th>
                            <th>Update Time</th>
                            <th>Status</th>
                        </tr>
                        </thead>
                        <tbody>
                        {tabledata}
                        </tbody>
                    </table>
                </div>
                {/* /.card-body */}
            </div>
            {/* /.card */}
        </>)
    }
    wizard_1_btn = (event,value) => {
        event.preventDefault();

        if (value.status == "WAITING FOR ORDER") {
            let baseurl = myconfig.getemptywfo;
            let sid = new URLSearchParams(this.props.location.search).get("sid");
            let user = new URLSearchParams(this.props.location.search).get("user");
            let allocate_id = new URLSearchParams(this.props.location.search).get("allocate_id");
            axios.post(baseurl, {
                "sid": sid,
                "user": user,
                "allocate_id": allocate_id,
            }, {cancelToken: source.token}).then(res => {
                console.log(res.data)
                if (res.data.auth == false) {
                    /*  window.localStorage.setItem("fas_sid", null);
                      window.localStorage.setItem("fas_username", null);
                      window.localStorage.setItem("fas_name", null);
                      var win = window.open(redirecttologin, "_self");*/
                } else if (res.data.success == false) {
                    Swal.fire({
                        title: 'Error!',
                        text: res.data.msg,
                        icon: 'error',
                        confirmButtonText: 'Okay'
                    })
                } else {
                    if (res.data.isfound) {
                        this.setState({
                            a_distance_empty:res.data.data.a_distance_empty,
                            a_fule_empty:res.data.data.a_fule_empty,
                            estfuelqtyempty:res.data.data.a_fule_qty_empty,
                            estprediemempty:res.data.data.a_handling_empty,
                            esthandlefeeempty:res.data.data.a_perdiem_empty,

                            actfuelqtyempty:res.data.data.a_fule_qty_empty,
                            actprediemempty:res.data.data.a_handling_empty,
                            acthandlefeeempty:res.data.data.a_perdiem_empty,

                            truck:value.plate_no,
                            capcity:"400",
                            transporter:value.tran_name,
                            type:value.tran_type,
                            trailer:value.tra_plateno,
                            driver:value.dri_name,
                            licence:value.licence,
                            validity:value.validity,
                            phone:value.dri_phoneno,
                            assignshow:false,
                            wizard:1,
                            assignment_id:value.id,
                            wiz_algo:1,
                        })
                        Swal.fire({
                            title: 'Success!',
                            text: "Vehicle select successfully",
                            icon: 'success',
                            confirmButtonText: 'Okay'
                        })
                    } else {
                        Swal.fire({
                            title: 'Error!',
                            text: res.data.msg,
                            icon: 'error',
                            confirmButtonText: 'Okay'
                        })
                    }
                }
            }).catch((e) => {
                console.log(e.message);
            });
        }
        else if(value.status=="HEADING TO STATION"){
            this.setState({
                wizard:2,
                value:value,
            })
        }
    }
    wizard_2=()=>{
        return(<>
            <div className="card card-warning card-outline">
                <div className="card-header">
                    <h3 className="card-title">
                        <i className="fas fa-search" /> Type of trip select
                    </h3>
                </div>
                <div className="card-body">
                    <div className="row">
                        <div className="col-md-6">
                            <div className="form-group">
                                <button type="button" onClick={(event => this.wizard_2_btn(event,3))} className="form-control btn btn-success">
                                    From GPS
                                </button>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="form-group">
                                <button type="button" onClick={(event => this.wizard_2_btn(event,1))} className="form-control btn btn-dark">
                                    Same as Orgin
                                </button>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="form-group">
                                <button type="button" onClick={(event => this.wizard_2_btn(event,2))} className="form-control btn btn-dark">
                                From Route Master
                                </button>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="form-group">
                                <button type="button" className="form-control btn btn-info">
                                    Others
                                </button>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="form-group">
                                <button type="button" className="form-control btn btn-danger">
                                    Cancel
                                </button>
                            </div>
                        </div>
                    </div>
                    <div className="text-muted mt-3">
                        For more information look at <a href="#">apps.ztsus.com</a>
                    </div>
                </div>
            </div>
        </>)
    }
    wizard_2_btn = (event,type) => {
        //type 1 for Same as load
        //type 2 for from load point
        event.preventDefault();
        if(type==1){
            let value = this.state.value;
            let baseurl = myconfig.getemptysameasorg;
            let sid = new URLSearchParams(this.props.location.search).get("sid");
            let user = new URLSearchParams(this.props.location.search).get("user");
            let allocate_id = new URLSearchParams(this.props.location.search).get("allocate_id");
            axios.post(baseurl, {
                "sid": sid,
                "user": user,
                "allocate_id": allocate_id,
            }, {cancelToken: source.token}).then(res => {
                console.log(res.data)
                if (res.data.auth == false) {
                    /*  window.localStorage.setItem("fas_sid", null);
                      window.localStorage.setItem("fas_username", null);
                      window.localStorage.setItem("fas_name", null);
                      var win = window.open(redirecttologin, "_self");*/
                } else if (res.data.success == false) {
                    Swal.fire({
                        title: 'Error!',
                        text: res.data.msg,
                        icon: 'error',
                        confirmButtonText: 'Okay'
                    })
                } else {
                    this.setState({
                        a_distance_empty: res.data.data.a_distance_empty,
                        a_fule_empty: res.data.data.a_fule_empty,
                        estfuelqtyempty:res.data.data.a_fule_qty_empty,
                        estprediemempty:res.data.data.a_handling_empty,
                        esthandlefeeempty:res.data.data.a_perdiem_empty,
                        actfuelqtyempty:res.data.data.a_fule_qty_empty,
                        actprediemempty:res.data.data.a_handling_empty,
                        acthandlefeeempty:res.data.data.a_perdiem_empty,
                        truck: value.plate_no,
                        capcity: "400",
                        transporter: value.tran_name,
                        type: value.tran_type,
                        trailer: value.tra_plateno,
                        driver: value.dri_name,
                        licence: value.licence,
                        validity: value.validity,
                        phone: value.dri_phoneno,
                        assignshow: false,
                        wizard: 1,
                        assignment_id: value.id,
                        wiz_algo: 2,
                    })
                    Swal.fire({
                        title: 'Success!',
                        text: "Vehicle select successfully",
                        icon: 'success',
                        confirmButtonText: 'Okay'
                    })
                }
            }).catch((e) => {
                console.log(e.message);
            });
        }
        else if(type==2){
            let baseurl = myconfig.getlocations;
            let redirecttologin = myconfig.redirecttologin;
            axios.post(baseurl, {
            }, {cancelToken: source.token}).then(res => {
                console.log(res.data)
                if (res.data.auth == false) {
                    /*  window.localStorage.setItem("fas_sid", null);
                      window.localStorage.setItem("fas_username", null);
                      window.localStorage.setItem("fas_name", null);
                      var win = window.open(redirecttologin, "_self");*/
                } else if (res.data.success == false) {
                    Swal.fire({
                        title: 'Error!',
                        text: res.data.message,
                        icon: 'error',
                        confirmButtonText: 'Okay'
                    })
                } else {
                    this.setState({
                        locations:res.data.datas,
                        locationload:true,
                        locationselected:"-1",
                        wizard:3,
                    })
                }
            }).catch((e) => {
                console.log(e.message);
            });
        }
        else if(type==3){
            this.setState({
                wizard:4,
            })
        }
    }
    wizard_3=()=>{
        let dataoption=null;
        if(this.state.locationload){
            dataoption=this.state.locations.map(value => {
                return (<option value={value.id}>{value.loc_full_name}</option>)
            })
        }
        return(<>
            <div className="card card-warning card-outline">
                <div className="card-header">
                    <h3 className="card-title">
                        <i className="fas fa-book" /> From Route Master
                    </h3>
                </div>
                <div className="card-body">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="col-md-12">
                                <div className="form-group">
                                    <label>Route Orgin</label>
                                    <select name="locationselected" value={this.state.locationselected} className="form-control" onChange={this.inputmgt}>
                                        {dataoption}
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="card-footer">
                    <button type="submit" className="btn btn-primary" onClick={this.wizard_3_btn}>Select</button>
                </div>
            </div>
        </>)
    }
    wizard_3_btn = (event) => {
        event.preventDefault()
        let baseurl = myconfig.getemptyroadroute;
        let redirecttologin = myconfig.redirecttologin;
        let sid = new URLSearchParams(this.props.location.search).get("sid");
        let user = new URLSearchParams(this.props.location.search).get("user");
        let allocate_id = new URLSearchParams(this.props.location.search).get("allocate_id");
        axios.post(baseurl, {
            allocate_id:allocate_id,
            locationselected:this.state.locationselected,
        }, {cancelToken: source.token}).then(res => {
            console.log(res.data)
            if (res.data.auth == false) {
                /*  window.localStorage.setItem("fas_sid", null);
                  window.localStorage.setItem("fas_username", null);
                  window.localStorage.setItem("fas_name", null);
                  var win = window.open(redirecttologin, "_self");*/
            } else if (res.data.success == false) {
                Swal.fire({
                    title: 'Error!',
                    text: res.data.msg,
                    icon: 'error',
                    confirmButtonText: 'Okay'
                })
            } else {
                let value = this.state.value;
                this.setState({
                    a_distance_empty:res.data.data.a_distance_empty,
                    a_fule_empty:res.data.data.a_fule_empty,
                    estfuelqtyempty:res.data.data.a_fule_qty_empty,
                    estprediemempty:res.data.data.a_handling_empty,
                    esthandlefeeempty:res.data.data.a_perdiem_empty,
                    actfuelqtyempty:res.data.data.a_fule_qty_empty,
                    actprediemempty:res.data.data.a_handling_empty,
                    acthandlefeeempty:res.data.data.a_perdiem_empty,
                    truck:value.plate_no,
                    capcity:"400",
                    transporter:value.tran_name,
                    type:value.tran_type,
                    trailer:value.tra_plateno,
                    driver:value.dri_name,
                    licence:value.licence,
                    validity:value.validity,
                    phone:value.dri_phoneno,
                    assignshow:false,
                    wizard:1,
                    assignment_id:value.id,
                    wiz_algo:3,
                })
                Swal.fire({
                    title: 'Success!',
                    text: "Vehicle select successfully",
                    icon: 'success',
                    confirmButtonText: 'Okay'
                })
            }
        }).catch((e) => {
            console.log(e.message);
        });
    }
    wizard_4=()=>{
        return(<>
            <div className="card card-warning card-outline">
                <div className="card-header">
                    <h3 className="card-title">
                        <i className="fas fa-gears" /> From GPS Data
                    </h3>
                </div>
                <div className="card-body">
                    <form>
                        <div className="row">
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label>Current Location</label>
                                    <input name="cur_location" value={this.state.cur_location} className="form-control" type="text" onChange={this.inputmgt}/>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label>Current Coordinate</label>
                                    <input  name="cur_cor" value={this.state.cur_cor} className="form-control" type="text" onChange={this.inputmgt}/>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label>Update Time</label>
                                    <input disabled name="cur_avl" value={this.state.cur_avl} className="form-control" type="text" onChange={this.inputmgt}/>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label>Distance</label>
                                    <input  name="cur_distance" value={this.state.cur_distance} className="form-control" type="text" onChange={this.inputmgt}/>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label>Location Short Name</label>
                                    <input  name="cur_short_name" value={this.state.cur_short_name} className="form-control" type="text" onChange={this.inputmgt}/>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label>Fuel Empty</label>
                                    <input  name="cur_fuel_empty" value={this.state.cur_fuel_empty} className="form-control" type="text" onChange={this.inputmgt}/>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label>Handling Fee Empty</label>
                                    <input  name="cur_handling_fee" value={this.state.cur_handling_fee} className="form-control" type="text" onChange={this.inputmgt}/>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
                <div className="card-footer d-flex justify-content-between">
                    <button type="submit" className="btn btn-primary" onClick={this.wizard_4_btn}>Submit</button>
                    <button type="submit" className="btn btn-primary" onClick={this.getfromgps}>From GPS</button>
                    <button type="submit" className="btn btn-primary" onClick={this.getfromcor}>From Coordinate</button>
                </div>
            </div>
        </>)
    }
    wizard_4_btn = (event) => {
        event.preventDefault()
        if (this.state.cur_location == "") {
            Swal.fire({
                title: 'Error!',
                text: "Please enter location",
                icon: 'error',
                confirmButtonText: 'Okay'
            })
        }
        else if (this.state.cur_cor == "") {
            Swal.fire({
                title: 'Error!',
                text: "Please enter location coordinate",
                icon: 'error',
                confirmButtonText: 'Okay'
            })
        }
        else if (this.state.cur_distance == "" || isNaN(this.state.cur_distance)) {
            Swal.fire({
                title: 'Error!',
                text: "Please enter distance",
                icon: 'error',
                confirmButtonText: 'Okay'
            })
        }
        else if (this.state.cur_distance < 0) {
            Swal.fire({
                title: 'Error!',
                text: "Distance must be equal to zero or above",
                icon: 'error',
                confirmButtonText: 'Okay'
            })
        }
        else if (this.state.cur_fuel_empty == "" || isNaN(this.state.cur_fuel_empty)) {
            Swal.fire({
                title: 'Error!',
                text: "Please enter fuel empty",
                icon: 'error',
                confirmButtonText: 'Okay'
            })
        }
        else if (this.state.cur_fuel_empty <= 0) {
            Swal.fire({
                title: 'Error!',
                text: "Fuel empty can not be zero and below",
                icon: 'error',
                confirmButtonText: 'Okay'
            })
        }
        else if (this.state.cur_handling_fee == "" || isNaN(this.state.cur_handling_fee)) {
            Swal.fire({
                title: 'Error!',
                text: "Please enter handling fee empty",
                icon: 'error',
                confirmButtonText: 'Okay'
            })
        }
        else if (this.state.cur_handling_fee < 0) {
            Swal.fire({
                title: 'Error!',
                text: "Handling fee must be equal to zero or above",
                icon: 'error',
                confirmButtonText: 'Okay'
            })
        }
        else {
            let value = this.state.value;
            let cur_distance=parseFloat(this.state.cur_distance);
            let cur_fuel_empty=parseFloat(this.state.cur_fuel_empty);
            let cur_fule_qty_empty=parseFloat(cur_distance/cur_fuel_empty).toFixed(2)
            let cur_perdiem_empty=parseFloat(cur_distance*4.33*0.25).toFixed(2)
            let cur_handling_fee=parseFloat(this.state.cur_handling_fee);
            this.setState({
                a_distance_empty:cur_distance,
                a_fule_empty:cur_fuel_empty,
                estfuelqtyempty:cur_fule_qty_empty,
                estprediemempty:cur_perdiem_empty,
                esthandlefeeempty:cur_handling_fee,
                actfuelqtyempty:cur_fule_qty_empty,
                actprediemempty:cur_perdiem_empty,
                acthandlefeeempty:cur_handling_fee,
                truck:value.plate_no,
                capcity:"400",
                transporter:value.tran_name,
                type:value.tran_type,
                trailer:value.tra_plateno,
                driver:value.dri_name,
                licence:value.licence,
                validity:value.validity,
                phone:value.dri_phoneno,
                assignshow:false,
                wizard:1,
                assignment_id:value.id,
                wiz_algo:4,
            })
            Swal.fire({
                title: 'Success!',
                text: "Vehicle select successfully",
                icon: 'success',
                confirmButtonText: 'Okay'
            })
        }
    }
    getfromgps = (event) => {
        event.preventDefault()
        let baseurl = myconfig.getemptyfromgps;
        let redirecttologin = myconfig.redirecttologin;
        let sid = new URLSearchParams(this.props.location.search).get("sid");
        let user = new URLSearchParams(this.props.location.search).get("user");
        let allocate_id = new URLSearchParams(this.props.location.search).get("allocate_id");
        console.log(this.state.value)
        axios.post(baseurl, {
            allocate_id:allocate_id,
            truck_id:this.state.value.truck_id,
            sid:sid,
            user:user,
        }, {cancelToken: source.token}).then(res => {
            console.log(res.data)
            if (res.data.auth == false) {
                /*  window.localStorage.setItem("fas_sid", null);
                  window.localStorage.setItem("fas_username", null);
                  window.localStorage.setItem("fas_name", null);
                  var win = window.open(redirecttologin, "_self");*/
            } else if (res.data.success == false) {
                Swal.fire({
                    title: 'Error!',
                    text: res.data.msg,
                    icon: 'error',
                    confirmButtonText: 'Okay'
                })
            } else {
                this.setState({
                    cur_distance:res.data.data.cur_distance,
                    cur_location:res.data.data.cur_location,
                    cur_cor:res.data.data.cur_cor,
                    cur_avl:res.data.data.cur_avl,
                })
            }
        }).catch((e) => {
            console.log(e.message);
        });
    }
    getfromcor = (event) => {
        event.preventDefault()
        let baseurl = myconfig.getemptyfromcor;
        let redirecttologin = myconfig.redirecttologin;
        let sid = new URLSearchParams(this.props.location.search).get("sid");
        let user = new URLSearchParams(this.props.location.search).get("user");
        let allocate_id = new URLSearchParams(this.props.location.search).get("allocate_id");
        axios.post(baseurl, {
            allocate_id:allocate_id,
            truck_id:this.state.value.truck_id,
            sid:sid,
            user:user,
            cur_cor:this.state.cur_cor,
        }, {cancelToken: source.token}).then(res => {
            console.log(res.data)
            if (res.data.auth == false) {
                /*  window.localStorage.setItem("fas_sid", null);
                  window.localStorage.setItem("fas_username", null);
                  window.localStorage.setItem("fas_name", null);
                  var win = window.open(redirecttologin, "_self");*/
            } else if (res.data.success == false) {
                Swal.fire({
                    title: 'Error!',
                    text: res.data.msg,
                    icon: 'error',
                    confirmButtonText: 'Okay'
                })
            } else {
                this.setState({
                    cur_distance:res.data.data.cur_distance,
                })
            }
        }).catch((e) => {
            console.log(e.message);
        });
    }

    reset=()=>{
        this.setState({
            origin: "-1",
            des: "-1",
            orderdate: '',
            client: '',
            cargo_id: "-1",
            loadpoint_id: "-1",
            distance:'',
            fuelempty:'',
            fuelload:'',
            perdiemempty:'',
            allowancloaded:'',
            handlinefeeempty:'',
            handlinefeeloaded:'',
            isroutefound: false,
        })
    }
    btnsave =async (event) => {
        event.preventDefault();
        if (this.state.assignment_id == "-1")
            Swal.fire({
                title: 'Error!',
                text: "Select truck",
                icon: 'error',
                confirmButtonText: 'Okay'
            })
        else if (isNaN(this.state.fuelrate) || this.state.fuelrate == "")
            Swal.fire({
                title: 'Error!',
                text: "Fuel rate must be numeric",
                icon: 'error',
                confirmButtonText: 'Okay'
            })
        else {
            let baseurl = myconfig.createallocation;
            /*if(this.state.isupdate)
                baseurl = myconfig.updateorder;*/
            let redirecttologin = myconfig.redirecttologin;
            let sid = new URLSearchParams(this.props.location.search).get("sid");
            let user = new URLSearchParams(this.props.location.search).get("user");
            let allocate_id = new URLSearchParams(this.props.location.search).get("allocate_id");
            await axios.post(baseurl, {
                "sid": sid,
                "user": user,
                "allocation_id": allocate_id,
                "wiz_algo": this.state.wiz_algo,
                "assignment_id": this.state.assignment_id,
                "fuelrate": this.state.fuelrate,
                "dateofallocation": this.state.dateofallocation,
                "dateofallocationt": this.state.dateofallocationt,
                "dateofarivalatloadpoint": this.state.dateofarivalatloadpoint,
                "dateofloading": this.state.dateofloading,
                "dateofdeparture": this.state.dateofdeparture,
                "dateofarivalatboarder": this.state.dateofarivalatboarder,
                "dateofdepartureatboarder": this.state.dateofdepartureatboarder,
                "dateofarivalatoffloadpoint": this.state.dateofarivalatoffloadpoint,
                "dateofoffloading": this.state.dateofoffloading,
                "supervisor": this.state.supervisor,
                "dateofarivalatloadpointt": this.state.dateofarivalatloadpointt,
                "dateofloadingt": this.state.dateofloadingt,
                "dateofdeparturet": this.state.dateofdeparturet,
                "dateofarivalatoffloadpointt": this.state.dateofarivalatoffloadpointt,
                "dateofoffloadingt": this.state.dateofoffloadingt,
                "locationselected": this.state.locationselected,
                "cur_location": this.state.cur_location,
                "cur_cor": this.state.cur_cor,
                "cur_distance": this.state.cur_distance,
                "cur_short_name": this.state.cur_short_name,
                "cur_fuel_empty": this.state.cur_fuel_empty,
                "cur_handling_fee": this.state.cur_handling_fee,
                "actfuelqtyempty": this.state.actfuelqtyempty,
                "actprediemempty": this.state.actprediemempty,
                "acthandlefeeempty": this.state.acthandlefeeempty,
                "actfuelqtyload": this.state.actfuelqtyload,
                "actpredieload": this.state.actpredieload,
                "acthandlefeeload": this.state.acthandlefeeload,
                "commesa": this.state.commesa,
                "boardercost": this.state.boardercost,
                "loadedweight": this.state.loadedweight,
            }, {cancelToken: source.token}).then(res => {
                console.log(res.data)
                if (res.data.auth == false) {
                    /*  window.localStorage.setItem("fas_sid", null);
                      window.localStorage.setItem("fas_username", null);
                      window.localStorage.setItem("fas_name", null);
                      var win = window.open(redirecttologin, "_self");*/
                } else if (res.data.success == false) {
                    Swal.fire({
                        title: 'Error!',
                        text: res.data.msg,
                        icon: 'error',
                        confirmButtonText: 'Okay'
                    })
                } else {
                    Swal.fire({
                        title: 'Success',
                        text: res.data.msg,
                        icon: 'success',
                        confirmButtonText: 'Okay',

                    }).then(value => {
                        this.successumit()
                    })
                }
            }).catch((e) => {
                console.log(e.message);
            });
        }
    }
    successumit=()=> {
        if (this.state.isupdate) {
            window.location.href = this.state.urlallocate
        } else
            this.reset()
    }

    assignvehicle = (event) => {
        event.preventDefault()
        this.setState({
            assignment_id:"-1",
            vehicles:[],
            vehicleload:false,
            a_distance_empty:'',
            a_fule_empty:'',
            estfuelqtyempty:'',
            estprediemempty:'',
            esthandlefeeempty:'',
            truck:'NA',
            capcity:'NA',
            type:'NA',
            transporter:'NA',
            trailer:'NA',
            driver:'NA',
            licence:'NA',
            validity:'NA',
            phone:'NA',
            value:null,
            locations:[],
            locationload:false,
            locationselected:"-1",
            cur_location:'',
            cur_cor:'',
            cur_avl:'',
            cur_distance:'',
            cur_short_name:'',
            cur_fuel_empty:'',
            cur_handling_fee:'',
        })
        let baseurl = myconfig.getavavehicles;
        let sid = new URLSearchParams(this.props.location.search).get("sid");
        let user = new URLSearchParams(this.props.location.search).get("user");

        axios.post(baseurl, {
            "sid": sid,
            "user": user,
        }, {cancelToken: source.token}).then(res => {
            console.log(res.data)
            if (res.data.auth == false) {
                /*  window.localStorage.setItem("fas_sid", null);
                  window.localStorage.setItem("fas_username", null);
                  window.localStorage.setItem("fas_name", null);
                  var win = window.open(redirecttologin, "_self");*/
            } else if (res.data.success == false) {
                Swal.fire({
                    title: 'Error!',
                    text: res.data.message,
                    icon: 'error',
                    confirmButtonText: 'Okay'
                })
            } else {
                this.setState({
                    vehicles:res.data.datas,
                    vehicleload:true,
                    assignshow:true,
                    wizard:1,
                })
            }
        }).catch((e) => {
            console.log(e.message);
        });
    }
    hideassign = () => {
        this.setState({
            assignshow: false,
        })
    }
    modalassign=()=> {
        let display=null;
        let size="md";
        if(this.state.wizard==1){
            display=this.wizard_1()
            size="lg"
        }
        else if(this.state.wizard==2)
            display=this.wizard_2()
        else if(this.state.wizard==3)
            display=this.wizard_3()
        else if(this.state.wizard==4)
            display=this.wizard_4()
        else if(this.state.wizard==5)
            display=this.wizard_5()
        return (<Modal
                size={size}
                aria-labelledby="contained-modal-title-vcenter"
                centered
                show={this.state.assignshow}
                onHide={this.hideassign}>
                <Modal.Header><h4>Vehicle Assigment</h4>
                    <small>({this.state.msg})</small></Modal.Header>
                <Modal.Body>
                    <div className="row">
                        <div className="col-12">
                            {display}
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        )
    }
    btnassign = (event,assign_id) => {
        event.preventDefault();
        var name = event.target.name;
        var value = event.target.value;
        let id="-1"
        let vehplate='NA'
        let vehcapcity='NA'
        let vehtype='NA'
        let vehtname='NA'
        let traplate='NA'
        let driname='NA'
        let drilicno='NA'
        let drilicvalid='NA'
        let driphone='NA'
        let actfuelempty=''
        let actfuelload=''
        let actperdiumload=''
        let actallowanceempty=''
        let acthandlingempty=''
        let acthandlingload=''
        let estfuelempty=''
        let estfuelload=''
        let estperdiumload=''
        let estallowanceempty=''
        let esthandlingempty=''
        let esthandlingload=''
        let temp=this.state.objs.retvehicles.find(o=>o.id==assign_id)
        if(temp!==undefined)
        {
            console.log(temp)
            vehplate=temp.plateno
            vehcapcity=temp.capacity
            vehtype=temp.type
            vehtname=temp.tname

        }
        temp=this.state.objs.rettrailes.find(o=>o.id==assign_id)
        if(temp!==undefined)
        {
            traplate=temp.plateno
        }
        temp=this.state.vehicles.find(o=>o.assign_id==assign_id)

        if(temp!==undefined)
        {
            actfuelempty=temp.fuelqtyempty
            actfuelload=temp.fuelqtyload
            actperdiumload=temp.predimload
            actallowanceempty=temp.predimallownce
            acthandlingempty=temp.handlinefeeempty
            acthandlingload=temp.handlinefeeloaded

            estfuelempty=actfuelempty
            estfuelload=actfuelload
            estperdiumload=actperdiumload
            estallowanceempty=actallowanceempty
            esthandlingempty=acthandlingempty
            esthandlingload=acthandlingload
        }
        this.setState({
            [name]: value,
            vehplate:vehplate,
            vehcapcity:vehcapcity,
            vehtype:vehtype,
            vehtname:vehtname,
            traplate:traplate,
            driname:driname,
            drilicno:drilicno,
            drilicvalid:drilicvalid,
            driphone:driphone,
            assign:assign_id,
            actfuelempty:actfuelempty,
            actfuelload:actfuelload,
            actperdiumload:actperdiumload,
            actallowanceempty:actallowanceempty,
            acthandlingempty:acthandlingempty,
            acthandlingload:acthandlingload,
            estfuelempty:estfuelempty,
            estfuelload:estfuelload,
            estperdiumload:estperdiumload,
            estallowanceempty:estallowanceempty,
            esthandlingempty:esthandlingempty,
            esthandlingload:esthandlingload,
        })

        temp=this.state.objs.retdrivers.find(o=>o.id==assign_id)
        if(temp!==undefined)
        {
            driname=temp.name
            drilicno=temp.licenceno
            drilicvalid=temp.licencevalidty
            driphone=temp.phoneno
        }
        this.setState({
            [name]: value,
            vehcapcity:vehcapcity,
            vehtype:vehtype,
            vehtname:vehtname,
            traplate:traplate,
            driname:driname,
            drilicno:drilicno,
            drilicvalid:drilicvalid,
            driphone:driphone,
            assignshow: false,
        })
    }
    /* getKM =async (event) => {
         event.preventDefault();

         let sid = new URLSearchParams(this.props.location.search).get("sid");
         let user = new URLSearchParams(this.props.location.search).get("user");
         for (let i = 0; i < this.state.vehicles.length; i++) {
             let msg=(i+1)+" of "+(this.state.vehicles.length)
             this.setState({
                 msg:msg,
             })
             let assign_id = this.state.vehicles[i].assign_id
             let lat = this.state.lat
             let lon = this.state.lon
             let isactive = this.state.vehicles[i].isactive
             let km = "NA"
             if (isactive == true) {
                 let baseurl = myconfig.getKM;
                 let redirecttologin = myconfig.redirecttologin;
                 await  axios.post(baseurl, {
                     "sid": sid,
                     "user": user,
                     "assign_id":assign_id,
                     "lat":lat,
                     "lon":lon,
                 }, {cancelToken: source.token}).then(res => {
                     console.log(res.data)
                     if (res.data.auth == false) {
                         /!*  window.localStorage.setItem("fas_sid", null);
                           window.localStorage.setItem("fas_username", null);
                           window.localStorage.setItem("fas_name", null);
                           var win = window.open(redirecttologin, "_self");*!/
                     } else if (res.data.success == false) {
                         Swal.fire({
                             title: 'Error!',
                             text: res.data.message,
                             icon: 'error',
                             confirmButtonText: 'Okay'
                         })
                     }
                     else {
                         km=res.data.km
                         let temp=this.state.vehicles.map(value=>{
                             if(value.assign_id==this.state.vehicles[i].assign_id)
                                 value.leftkm=km
                             return value;
                         })
                         this.setState({
                             vehicles:temp,
                         })
                     }
                 }).catch((e) => {
                     console.log(e.message);
                 });
             }
         }
     }
 */

    componentWillUnmount() {
        try {
            if (source) {
                source.cancel("Landing Component got unmounted");
            }
        } catch (e) {

        }
    }
    menuhidden = (event) => {
        event.preventDefault();
        if (this.state.menu == "g-sidenav-show bg-gray-100")
            this.setState({
                menu: "g-sidenav-hidden bg-gray-100"
            })
        else
            this.setState({
                menu: "g-sidenav-show bg-gray-100"
            })
    }
    inputmgt = (event) => {
        event.preventDefault();
        var name = event.target.name;
        var value = event.target.value;
        this.setState({
            [name]: value,
        })
    }
    render() {
        return (
            <>
                <Nav type="oordermgt"/>
                <div className="content-wrapper">
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-6">
                                    <h1 className="m-0">Create Allocation</h1>
                                </div>
                                <div className="col-sm-6">
                                    <ol className="breadcrumb float-sm-right">
                                        <li className="breadcrumb-item"><a href={this.state.urlallocate}>Allocation List</a></li>
                                        <li className="breadcrumb-item active">Allocation Create</li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>
                    <section className="content">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-md-6">
                                    <div className="row">
                                        <div className="col-12">
                                            <div className="card card-primary">
                                                <div className="card-header">
                                                    <h3 className="card-title">Cost Empty</h3>
                                                </div>
                                                <form>
                                                    <div className="card-body">
                                                        <div className="row">
                                                            <div className="col-md-6">
                                                                <div className="form-group">
                                                                    <label>Distance</label>
                                                                    <input disabled name="a_distance_empty" value={this.state.a_distance_empty} className="form-control" type="text" onChange={this.inputmgt}/>
                                                                </div>
                                                            </div>
                                                            <div className="col-md-6">
                                                                <div className="form-group">
                                                                    <label>Fuel QTY Empty</label>
                                                                    <input disabled name="estfuelqtyempty" value={this.state.estfuelqtyempty} className="form-control" type="text" onChange={this.inputmgt}/>
                                                                </div>
                                                            </div>
                                                            <div className="col-md-6">
                                                                <div className="form-group">
                                                                    <label>Per Diem Empty</label>
                                                                    <input disabled className="form-control" type="text" name="estprediemempty" onChange={this.inputmgt} value={this.state.estprediemempty}/>
                                                                </div>
                                                            </div>
                                                            <div className="col-md-6">
                                                                <div className="form-group">
                                                                    <label>Handling Empty</label>
                                                                    <input disabled className="form-control" type="text" name="esthandlefeeempty" onChange={this.inputmgt} value={this.state.esthandlefeeempty}/>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="card-footer">
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                        <div className="col-12">
                                            <div className="card card-primary">
                                                <div className="card-header">
                                                    <h3 className="card-title">Cost Loaded</h3>
                                                </div>
                                                <form>
                                                    <div className="card-body">
                                                        <div className="row">
                                                            <div className="col-md-6">
                                                                <div className="form-group">
                                                                    <label>Fuel Loaded</label>
                                                                    <input disabled name="estfuelqtyload" value={this.state.estfuelqtyload} className="form-control" type="text" onChange={this.inputmgt}/>
                                                                </div>
                                                            </div>
                                                            <div className="col-md-6">
                                                                <div className="form-group">
                                                                    <label>Per Diem Loaded</label>
                                                                    <input disabled name="estpredieload" value={this.state.estpredieload} className="form-control" type="text" onChange={this.inputmgt}/>
                                                                </div>
                                                            </div>
                                                            <div className="col-md-6">
                                                                <div className="form-group">
                                                                    <label>Handling Loaded</label>
                                                                    <input disabled className="form-control" type="text" name="esthandlefeeload" onChange={this.inputmgt} value={this.state.esthandlefeeload}/>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="card-footer">
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="row">
                                        <div className="col-12">
                                            <div className="card card-primary">
                                                <div className="card-header">
                                                    <h3 className="card-title">Truck Allocation</h3>
                                                </div>
                                                <form>
                                                    <div className="card-body">
                                                        <div className="form-group">
                                                            <label>For Assigning Vehicle</label>
                                                            <button className="form-control btn btn-sm btn-outline-primary" onClick={this.assignvehicle}>Assign</button>
                                                        </div>
                                                        <div className="row">
                                                            <div className="col-md-6">
                                                                <div className="form-group">
                                                                    <label>Truck</label>
                                                                    <input disabled className="form-control" type="text" value={this.state.truck} name="truck" onChange={this.inputmgt}/>
                                                                </div>
                                                            </div>
                                                            <div className="col-md-6">
                                                                <div className="form-group">
                                                                    <label>Capacity</label>
                                                                    <input disabled className="form-control" type="text" value={this.state.capcity} name="capcity" onChange={this.inputmgt}/>
                                                                </div>
                                                            </div>
                                                            <div className="col-md-6">
                                                                <div className="form-group">
                                                                    <label>Type</label>
                                                                    <input disabled className="form-control" type="type" value={this.state.type} name="type" onChange={this.inputmgt}/>
                                                                </div>
                                                            </div>
                                                            <div className="col-md-6">
                                                                <div className="form-group">
                                                                    <label>Transporter</label>
                                                                    <input disabled className="form-control" type="text" value={this.state.transporter} name="transporter" onChange={this.inputmgt}/>
                                                                </div>
                                                            </div>
                                                            <div className="col-md-6">
                                                                <div className="form-group">
                                                                    <label>Trailer</label>
                                                                    <input disabled className="form-control" type="text" value={this.state.trailer} name="trailer" onChange={this.inputmgt}/>
                                                                </div>
                                                            </div>
                                                            <div className="col-md-6">
                                                                <div className="form-group">
                                                                    <label>Driver</label>
                                                                    <input disabled className="form-control" type="text" value={this.state.driver} name="driver" onChange={this.inputmgt}/>
                                                                </div>
                                                            </div>

                                                            <div className="col-md-6">
                                                                <div className="form-group">
                                                                    <label>Phone #</label>
                                                                    <input disabled className="form-control" type="text" value={this.state.phone} name="phone" onChange={this.inputmgt}/>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="card-footer">
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                        <div className="col-12">
                                            <div className="card card-primary">
                                                <div className="card-header">
                                                    <h3 className="card-title">Actual Cost</h3>
                                                </div>
                                                <form>
                                                    <div className="card-body">
                                                        <div className="row">
                                                            <div className="col-md-6">
                                                                <div className="form-group">
                                                                    <label>Fuel QTY Empty</label>
                                                                    <input name="actfuelqtyempty" value={this.state.actfuelqtyempty} className="form-control" type="text" onChange={this.inputmgt}/>
                                                                </div>
                                                            </div>
                                                            <div className="col-md-6">
                                                                <div className="form-group">
                                                                    <label>Fuel QTY Load  </label>
                                                                    <input name="actfuelqtyload" value={this.state.actfuelqtyload} className="form-control" type="text" onChange={this.inputmgt}/>
                                                                </div>
                                                            </div>
                                                            <div className="col-md-6">
                                                                <div className="form-group">
                                                                    <label>Per Diem Empty</label>
                                                                    <input className="form-control" type="text" name="actprediemempty" onChange={this.inputmgt} value={this.state.actprediemempty}/>
                                                                </div>
                                                            </div>
                                                            <div className="col-md-6">
                                                                <div className="form-group">
                                                                    <label>Per Diem Load</label>
                                                                    <input className="form-control" type="text" name="actpredieload" onChange={this.inputmgt} value={this.state.actpredieload}/>
                                                                </div>
                                                            </div>
                                                            <div className="col-md-6">
                                                                <div className="form-group">
                                                                    <label>Handling Empty</label>
                                                                    <input className="form-control" type="text" name="acthandlefeeempty" onChange={this.inputmgt} value={this.state.acthandlefeeempty}/>
                                                                </div>
                                                            </div>
                                                            <div className="col-md-6">
                                                                <div className="form-group">
                                                                    <label>Handling Load</label>
                                                                    <input className="form-control" type="text" name="acthandlefeeload" onChange={this.inputmgt} value={this.state.acthandlefeeload}/>
                                                                </div>
                                                            </div>
                                                            <div className="col-md-6">
                                                                <div className="form-group">
                                                                    <label>Commessa</label>
                                                                    <input className="form-control" type="text" name="commesa" onChange={this.inputmgt} value={this.state.commesa}/>
                                                                </div>
                                                            </div>
                                                            <div className="col-md-6">
                                                                <div className="form-group">
                                                                    <label>Border Charge</label>
                                                                    <input className="form-control" type="text" name="boardercost" onChange={this.inputmgt} value={this.state.boardercost}/>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="card-footer">
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                        <div className="col-12">
                                            <div className="card card-primary">
                                                <div className="card-header">
                                                    <h3 className="card-title">Date Allocation</h3>
                                                </div>
                                                <form>
                                                    <div className="card-body">
                                                        <div className="row">
                                                            <div className="col-md-8">
                                                                <div className="form-group">
                                                                    <label>Allocation</label>
                                                                    <input name="dateofallocation" value={this.state.dateofallocation} className="form-control" type="date" onChange={this.inputmgt}/>
                                                                </div>
                                                            </div>
                                                            <div className="col-md-4">
                                                                <div className="form-group">
                                                                    <label>Time</label>
                                                                    <input name="dateofallocationt" value={this.state.dateofallocationt} className="form-control" type="text" placeholder="HH:MM" onChange={this.inputmgt}/>
                                                                </div>
                                                            </div>
                                                            <div className="col-md-8">
                                                                <div className="form-group">
                                                                    <label>Arrival Loading</label>
                                                                    <input name="dateofarivalatloadpoint" value={this.state.dateofarivalatloadpoint} className="form-control" type="date" onChange={this.inputmgt}/>
                                                                </div>
                                                            </div>
                                                            <div className="col-md-4">
                                                                <div className="form-group">
                                                                    <label>Time</label>
                                                                    <input name="dateofarivalatloadpointt" value={this.state.dateofarivalatloadpointt} className="form-control" type="text" placeholder="HH:MM" onChange={this.inputmgt}/>
                                                                </div>
                                                            </div>
                                                            <div className="col-md-8">
                                                                <div className="form-group">
                                                                    <label>Loading</label>
                                                                    <input name="dateofloading" value={this.state.dateofloading} className="form-control" type="date" onChange={this.inputmgt}/>
                                                                </div>
                                                            </div>
                                                            <div className="col-md-4">
                                                                <div className="form-group">
                                                                    <label>Time</label>
                                                                    <input name="dateofloadingt" value={this.state.dateofloadingt} className="form-control" type="text" placeholder="HH:MM" onChange={this.inputmgt}/>
                                                                </div>
                                                            </div>
                                                            <div className="col-md-8">
                                                                <div className="form-group">
                                                                    <label>Departure</label>
                                                                    <input name="dateofdeparture" value={this.state.dateofdeparture} className="form-control" type="date" onChange={this.inputmgt}/>
                                                                </div>
                                                            </div>
                                                            <div className="col-md-4">
                                                                <div className="form-group">
                                                                    <label>Time</label>
                                                                    <input name="dateofdeparturet" value={this.state.dateofdeparturet} className="form-control" type="text" placeholder="HH:MM" onChange={this.inputmgt}/>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="form-group">
                                                            <label>Arrival at boarder</label>
                                                            <input name="dateofarivalatboarder" value={this.state.dateofarivalatboarder} className="form-control" type="date" onChange={this.inputmgt}/>
                                                        </div>
                                                        <div className="form-group">
                                                            <label>Departure at boarder</label>
                                                            <input name="dateofdepartureatboarder" value={this.state.dateofdepartureatboarder} className="form-control" type="date" onChange={this.inputmgt}/>
                                                        </div>
                                                        <div className="row">
                                                            <div className="col-md-8">
                                                                <div className="form-group">
                                                                    <label>Arrival offloading</label>
                                                                    <input name="dateofarivalatoffloadpoint" value={this.state.dateofarivalatoffloadpoint} className="form-control" type="date" onChange={this.inputmgt}/>
                                                                </div>
                                                            </div>
                                                            <div className="col-md-4">
                                                                <div className="form-group">
                                                                    <label>Time</label>
                                                                    <input name="dateofarivalatoffloadpointt" value={this.state.dateofarivalatoffloadpointt} className="form-control" type="text" placeholder="HH:MM" onChange={this.inputmgt}/>
                                                                </div>
                                                            </div>
                                                            <div className="col-md-8">
                                                                <div className="form-group">
                                                                    <label>Offloading</label>
                                                                    <input name="dateofoffloading" value={this.state.dateofoffloading} className="form-control" type="date" onChange={this.inputmgt}/>
                                                                </div>
                                                            </div>
                                                            <div className="col-md-4">
                                                                <div className="form-group">
                                                                    <label>Time</label>
                                                                    <input name="dateofoffloadingt" value={this.state.dateofoffloadingt} className="form-control" type="text" placeholder="HH:MM" onChange={this.inputmgt}/>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                </form>
                                            </div>
                                        </div>
                                        <div className="col-12">
                                            <div className="card card-primary">
                                                <div className="card-header">
                                                    <h3 className="card-title">Other Information</h3>
                                                </div>
                                                <form>
                                                    <div className="card-body">
                                                        <div className="form-group">
                                                            <label>Supervisor</label>
                                                            <input name="supervisor" value={this.state.supervisor} className="form-control" type="text" onChange={this.inputmgt}/>
                                                        </div>
                                                        <div className="form-group">
                                                            <label>Fuel Rate</label>
                                                            <input name="fuelrate" value={this.state.fuelrate} className="form-control" type="text" onChange={this.inputmgt}/>
                                                        </div>
                                                        <div className="form-group">
                                                            <label>Loaded Weight</label>
                                                            <input name="loadedweight"  value={this.state.loadedweight} className="form-control" type="text" onChange={this.inputmgt}/>
                                                        </div>
                                                        <div className="form-group">
                                                            <label>Any other cost</label>
                                                            <input name="otherexpense" value={this.state.otherexpense} className="form-control" type="text" onChange={this.inputmgt}/>
                                                        </div>
                                                        <div className="form-group">
                                                            <label>Cost</label>
                                                            <input disabled name="cost" value={this.state.cost} className="form-control" type="text" onChange={this.inputmgt}/>
                                                        </div>
                                                        <div className="form-group">
                                                            <label>Revenue birr</label>
                                                            <input disabled name="revbirr" value={this.state.revbirr} className="form-control" type="text" onChange={this.inputmgt}/>
                                                        </div>
                                                    </div>
                                                    <div className="card-footer">
                                                        <button type="submit" className="btn btn-primary" onClick={this.btnsave}>Submit</button>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </section>
                </div>
                {this.modalassign()}
            </>
        )
    }
}

export default AllocateCU;
